import { ChartsReferenceLine } from "@mui/x-charts";
import { BarChart } from "@mui/x-charts/BarChart";

function formatCurrency(amount) {
  return `$${amount.toFixed(2)}`;
}

function formatDate(timestamp) {
  const date = new Date(timestamp * 1000); // Convert seconds to milliseconds
  return date.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "2-digit",
  }); // Format the date
}

// a quick funtion to get the number of days in the current month
function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}

export default function Chart(props) {
  const { costs } = props;

  const dailyBudget = costs.budget?.amount
    ? costs.budget.amount /
      daysInMonth(new Date().getMonth() + 1, new Date().getFullYear())
    : false;

  let uData = [];
  let xLabels = [];

  costs.costs.map((cost) => {
    uData.push(cost.daily_cost).toFixed(2);
    xLabels.push(formatDate(cost.day.seconds));
  });

  return (
    <BarChart
      width={500}
      height={200}
      series={[{ data: uData.reverse(), id: "pvId" }]}
      xAxis={[{ data: xLabels.reverse(), scaleType: "band" }]}
    >
      {dailyBudget && (
        <ChartsReferenceLine
          y={dailyBudget}
          label={`Budget: ${formatCurrency(dailyBudget)}`}
          stroke="red"
        />
      )}
    </BarChart>
  );
}
